import { render } from "./ContrastSwitch.vue?vue&type=template&id=2f1eac58"
import script from "./ContrastSwitch.vue?vue&type=script&lang=js"
export * from "./ContrastSwitch.vue?vue&type=script&lang=js"

import "./ContrastSwitch.vue?vue&type=style&index=0&id=2f1eac58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__